module.exports = __webpack_public_path__ + "static/logo.9bf49f58.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/fullscreen/logo.png
// module id = 486
// module chunks = 114276838955818